/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.FieldsBean = factory(root.BpmbuildDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The FieldsBean model module.
   * @module model/FieldsBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>FieldsBean</code>.
   * @alias module:model/FieldsBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>FieldsBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FieldsBean} obj Optional instance to populate.
   * @return {module:model/FieldsBean} The populated <code>FieldsBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('allow_multiple_selections'))
        obj.allowMultipleSelections = ApiClient.convertToType(data['allow_multiple_selections'], 'Boolean');
      if (data.hasOwnProperty('allow_other_choice'))
        obj.allowOtherChoice = ApiClient.convertToType(data['allow_other_choice'], 'Boolean');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('ref'))
        obj.ref = ApiClient.convertToType(data['ref'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
    }
    return obj;
  }

  /**
   * @member {Boolean} allowMultipleSelections
   */
  exports.prototype.allowMultipleSelections = undefined;

  /**
   * @member {Boolean} allowOtherChoice
   */
  exports.prototype.allowOtherChoice = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {String} ref
   */
  exports.prototype.ref = undefined;

  /**
   * @member {String} title
   */
  exports.prototype.title = undefined;

  /**
   * @member {String} type
   */
  exports.prototype.type = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/FieldsBean.js